import { IconButton } from '~/components/ui/IconButton';
import { classNames } from '~/utils/classNames';

export type SortDir = 'ASC' | 'DESC' | undefined;

type Props = {
  activeField: string;
  sortField?: string;
  sortDirection?: SortDir;
  onSortChange?: (sortField: string, sortDirection?: SortDir) => void;
};

const getNextDir = (dir: SortDir): SortDir => {
  if (dir === 'ASC') {
    return 'DESC';
  }

  if (dir === 'DESC') {
    return undefined;
  }

  return 'ASC';
};

export const SortIndicator = ({ activeField, sortField, sortDirection, onSortChange }: Props) => {
  const isActive = sortField === activeField;
  const activeDir: SortDir | undefined = isActive ? sortDirection : undefined;

  const handleClick = () => {
    if (!onSortChange) {
      return;
    }

    onSortChange(activeField, getNextDir(activeDir));
  };

  const iconClass = (() => {
    if (activeDir === 'ASC') {
      return 'i-ph:arrow-up';
    }

    if (activeDir === 'DESC') {
      return 'i-ph:arrow-down';
    }

    return 'i-ph:arrows-vertical';
  })();

  if (onSortChange) {
    return (
      <IconButton
        variant="ghost"
        icon={classNames(iconClass, 'size-3', { 'opacity-50': !isActive })}
        className="size-6 rounded-sm"
        onClick={handleClick}
        aria-label={activeDir === 'ASC' ? 'Sort descending' : activeDir === 'DESC' ? 'Clear sort' : 'Sort ascending'}
      />
    );
  }

  if (!isActive) {
    return null;
  }

  return <div className={classNames(iconClass, 'size-3')} />;
};
